// Reverse the keys and values of an object, this is used to give Zod something that looks like
// an enum, for the z.nativeEnum() function. It allows us to use our existing lookup objects
// unmodified.
export function reverseKeys(obj) {
    const keys = Object.keys(obj);
    const result = {};
    for (const key of keys) {
        const newKey = obj[key];
        result[newKey] = key;
    }
    return result;
}
